import { render } from "./CarouselScreenSlider.vue?vue&type=template&id=dafbd670"
import script from "./CarouselScreenSlider.vue?vue&type=script&lang=js"
export * from "./CarouselScreenSlider.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\market\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__